"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COW_DragonWhelp_FireBreathAbilityHandler = exports.COW_DragonWhelp_FireBreathActorAbilityFactory = exports.COW_DragonWhelp_FireBreathAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class COW_DragonWhelp_FireBreathAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.COW_DragonWhelp_FireBreath;
        this.__typeName = "COW_DragonWhelp_FireBreath";
    }
}
exports.COW_DragonWhelp_FireBreathAbilityArgs = COW_DragonWhelp_FireBreathAbilityArgs;
let COW_DragonWhelp_FireBreathActorAbilityFactory = class COW_DragonWhelp_FireBreathActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("COW_DragonWhelp_FireBreath", "AllEnemies", 2);
    }
};
COW_DragonWhelp_FireBreathActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("COW_DragonWhelp_FireBreath")
], COW_DragonWhelp_FireBreathActorAbilityFactory);
exports.COW_DragonWhelp_FireBreathActorAbilityFactory = COW_DragonWhelp_FireBreathActorAbilityFactory;
let COW_DragonWhelp_FireBreathAbilityHandler = class COW_DragonWhelp_FireBreathAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 70)
                ],
                effects: [
                    {
                        duration: Duration_1.Duration.Turns(8),
                        targetId,
                        effect: new core_1.BurningEffectArgs("Focus", 10)
                    }
                ]
            }))
        });
    }
};
COW_DragonWhelp_FireBreathAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.COW_DragonWhelp_FireBreath)
], COW_DragonWhelp_FireBreathAbilityHandler);
exports.COW_DragonWhelp_FireBreathAbilityHandler = COW_DragonWhelp_FireBreathAbilityHandler;
